import React, { useState } from 'react';
// import { Box, TextField, IconButton, Typography, Paper, Button, Grid, Pagination } from '@mui/material';
import { Box, TextField, IconButton, Typography, Paper, Button, Grid, Pagination, Skeleton  } from '@barracuda-internal/bds-core';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

const PAGE_SIZE = 20;

export default function SubDomains({ }) {
  return (
    <Box sx={{ width: '100%', mx: 'auto', mt: 3 }}>
      <Typography variant="h5" gutterBottom>
        Subdomains
      </Typography>
      <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
        <TextField
          label="Search subdomains"
          variant="outlined"
          size="small"
          sx={{ flex: 1 }}
          disabled
        />
        <Button
          bdsType="interactiveNeutral"
          disabled={true}
        >
          Export CSV
        </Button>
      </Box>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          {[1,2,3,4,5,6,7,8].map((domain, idx) => (
            <Box key={idx} sx={{ display: 'flex', alignItems: 'center', mb: 1, pl: 1 }}>
              <Skeleton variant="text" sx={{ fontSize: '1rem' }} width={600} />
            </Box>
          ))}
        </Grid>
        <Grid item xs={12} sm={6}>
          {[1,2,3,4,5,6,7,8].map((domain, idx) => (
            <Box key={idx} sx={{ display: 'flex', alignItems: 'center', mb: 1, pl: 1 }}>
              <Skeleton variant="text" sx={{ fontSize: '1rem' }} width={600} />
            </Box>
          ))}
        </Grid>
      </Grid>
    </Box>
  );
}
